import $ from 'jquery';

const $contactMessage = $('.contact-form__message');
const $contactMessageButton = $('.contact-form__message-button');

$contactMessageButton.on('click', () => {
    $contactMessage.addClass('none');
});